export function priceHandler(input, currency = 'HKD', numberOnly = false) {
	if (!input) return '-';

	const price = parseInt(input) / 100;
	if (numberOnly){
		return Number(price.toFixed(1)).toLocaleString();
	}
	return currency + ' $' + Number(price.toFixed(1)).toLocaleString();
}